import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from 'axios';
import { Link } from 'react-router-dom'
import Navbar from './Navbar'


class CheckOut extends Component{
    constructor(props) {
        super(props);

        this.state={
            timeSlots:[],
        firstName: "",
        email:"",
        phone:"",
        deliveryType:"",
        vehicle:"",
        allergy:"",
        pickupTime:"",
        picktime:"",
        payType:"",
        showSubmit: parseInt(props.total)>0,
        disabled : true,
        idorder : "",
        id:'',
        startTime:"",
        endTime:"", 
        loading:false    
            }
        } ;          

        componentDidMount() {
            fetch('https://apps2.housing.k-state.edu/code/JPsatJardine/getTime.php?revenue=JPs')
            .then((response) => {
              return response.json();
            }) .then(data => {
                this.setState({ timeSlots: data.timeArray })
                this.setState({ startTime: data.startTime })
                this.setState({ endTime: data.endTime })
            });           
        }
    
    handleCheckOut = (e)=>{
      var that = this;
       const bodyFormData = new FormData(); 
       bodyFormData.append('addedItem', JSON.stringify(this.props.orders));
       bodyFormData.append('person', JSON.stringify(this.state));
       bodyFormData.append('total', this.props.total);
      
        axios.post(`https://apps2.housing.k-state.edu/code/JPsatJardine/paymentShoppingCart.php`, bodyFormData)
        .then(function (response) {
           var data= response.data;
          
           if(data.payType == "Credit Card"){
           window.location.replace("https://apps2.housing.k-state.edu/code/JPsatJardine/shoppingRedirect.php?idOrder="+data.idOrder)  
        }else if(data.payType == "Dining Dollars"){
            if(localStorage.getItem("wid")){
                that.props.history.push({
                    pathname: '/diningdollar',
                    state: { idOrder: data.idOrder }
                  })
            }else{
                const openedWindow =window.open("https://apps2.housing.k-state.edu/code/jpsatjardine/diningDollarLogin.php");  
                function loop(){
                    that.setState({ loading: true })      
              setTimeout(function () {
                  if(openedWindow.closed){
                   //  localStorage.setItem("wid",866399048);
               if(localStorage.getItem("wid")){  
                that.setState({ loading: false })               
               that.props.history.push({
                pathname: '/diningdollar',
                state: { idOrder: data.idOrder }
              })
               }
            }else{
                loop();
            }
            }, 3000); 
        }  
         loop();  
        }
       
        }
        })
       
    }
    setValues= (e)=>{
        

       
        this.setState({ [e.target.name]:e.target.value});   
        if(this.state.deliveryType== "Pickup"){
            this.setState({ vehicle:""});   
        }                              
    }
    

    render(){  
         // date and time
        var tempDate = new Date();
        var currDate =  (tempDate.getMonth()+1)  + '/' +tempDate.getDate() + '/' + tempDate.getFullYear()
     
        var hours =  tempDate.getHours();
        var minutes= tempDate.getMinutes()
        var seconds= tempDate.getSeconds()
        var ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12;
         if (hours   < 10) {hours   = "0"+hours;}
         if (minutes < 10) {minutes = "0"+minutes;}
         if (seconds < 10) {seconds = "0"+seconds;}
         var currTime= hours+':'+minutes+' '+ ampm;
        var showAsap = false
        var MS_PER_MINUTE = 60000;  
         
        var endTime = Date.parse(currDate+" "+this.state.endTime)-(20*MS_PER_MINUTE);
if(Date.parse(currDate+" "+currTime)<Date.parse(currDate+" "+this.state.startTime) || Date.parse(currDate+" "+currTime)>endTime ){
    
    showAsap = false
}else{
    showAsap = true
}


        var  phno = /^[2-9]\d{2}\d{3}\d{4}$/;
        var phone="";
        var name= /^[a-z\d\-_\s]+$/i;
        var alphName="";
        if(this.state.phone){
           
            if(this.state.phone.match(phno)){
                 phone =true;
            }else{
                 phone =false;
            }
        }
        if(this.state.firstName){
           
            if(this.state.firstName.match(name)){
                alphName =true;
            }else{
                alphName =false;
            }
        }
        var disable
        if((this.state.firstName == "") || (this.state.lastName == "") || !this.state.email || !this.state.phone  || this.props.orders.length == 0 ||
         phone ==  false  || alphName ==  false || (this.state.deliveryType=="") || (this.state.pickupTime == "") || this.state.payType==""){
            
            disable = true;

            
        }else{
            if(this.state.pickupTime == "Scheduled"){


                if(this.state.picktime == "" || this.state.picktime == "Select time" ){
                    disable = true
                } else{
                    if(this.state.deliveryType === "Curbside"){
                        if(this.state.vehicle == ""){
                            disable = true
                        }
                    }else{
                        disable=false
                    }

                }
   
            }else{
                if(this.state.deliveryType === "Curbside"){
                    if(this.state.vehicle == ""){
                        disable = true
                    }else{
                      disable=  false
                    }
                }
            }
           
        } 
  
        return(
            <div>
            <Navbar isAuthed={false}/>
            <div className="container"> 
                 
                    <br/>        
                   
                    <div className="checkout">
                        <h5>My Information</h5>
                    {/* <ul className="collection">
                      <p>Total</p>  
                    
                    <li>
                    <span  className="title">Sub Total: ${parseFloat(this.props.total).toFixed(2)}</span>&nbsp;&nbsp;&nbsp;
                    <span>Tax: ${parseFloat((this.props.total*taxrate)).toFixed(2)}</span>&nbsp;&nbsp;
                    <span>Total: ${parseFloat(this.props.total*(1+taxrate)).toFixed(2)}</span>
                    </li></ul> */}
                       
                      <br/>
                      
        <div class="input-field col s6">
        <label  class="myinfo" style={{color:"Black"}}for="first_name"><b>Name:</b><span style={{color:"red"}} className="error">* </span></label>
         
          <input  id="firstName"  ref="firstName" name= "firstName" onChange={this.setValues}  defaultValue={this.state.firstName} pattern="[a-zA-Z0-9\s]+"  type="text"  class="validate" required/>
         <span class="helper-text" data-error="Please avoid special characters" data-success=""></span> 
        </div>
        {/* <div class="input-field col s6">
          <input id="lastName"  name= "lastName" onChange={this.setValues} defaultValue={this.state.lastName}  type="text"  required/>
          <label  class="myinfo" style={{color:"Black"}} for="last_name"><b>Last Name:</b><span className="error">* </span></label>
        </div> */}
     
                        
                        <div className="input-field col s6 ">
                        <label   style={{color:"Black"}} className="col-sm-2 myinfo" htmlFor="email"><b>Email:</b> <span style={{color:"red"}} className="error">* </span></label>
                        <input  className="col-sm-3 form-control" id="email" name= "email"  type="email" onChange={this.setValues} defaultValue={this.state.email}  required/>
                        </div>

                        <div className="input-field col s6  " style={{height:"59px"}}>
                        <label style={{color:"Black"}} className="col-sm-2 myinfo" htmlFor="phone"><b>Phone:</b> <span style={{color:"red"}} className="error">* </span> </label>
                        <input className="col-sm-3 form-control" pattern="[0-9]{3}[0-9]{3}[0-9]{4}" name="phone" id="phone" type="tel"  class="validate" onChange={this.setValues}  required/>
                        <span class="helper-text" data-error="Please match the format XXXXXXXXXX" data-success=""></span> 
                        </div>
                        <div className="form-inline ">
                        <label  style={{color:"Black"}} className="col-sm-2 myinfo" htmlFor="deliverType" ><b>Select a Pickup Method: </b><span style={{color:"red"}} className="error">* </span></label>  
                        <label >
                    <input type="radio" class="btn"  name="deliveryType" id="Pickup" value="Pickup"  onChange={this.setValues} required="" aria-required="true" />
                    <span style={{color:"Black"}}>In-restaurant</span></label> &nbsp;
                <label >
                    <input type="radio" class="" name="deliveryType" id="Curbside" value="Curbside" onChange={this.setValues} required="" aria-required="true" />
                    <span style={{color:"Black"}}>Curbside</span>
                </label>
                        </div>
                        {this.state.deliveryType == "Curbside" ? 
                        <div className="input-field col s6 ">
                        <label  style={{color:"Black"}} className="col-sm-2 myinfo" htmlFor="vehicle"><b>Vehicle Description:</b> <span style={{color:"red"}} className="error">* </span></label>
                        <input  className="col-sm-3 form-control" id="vehicle" name= "vehicle"  type="text" onChange={this.setValues} defaultValue={this.state.vehicle}  required/>
                        </div>:""}
<br/>
                        <div className="form-inline ">
                        <label  style={{color:"Black"}} className="col-sm-2 myinfo" htmlFor="pickupTime" ><b>Pickup Time: </b><span style={{color:"red"}} className="error">* </span></label>
                        {showAsap == true ? 
                        <label >
                    <input type="radio" class="btn"  name="pickupTime" id="ASAP" value="ASAP"  onChange={this.setValues} required="" aria-required="true" />
                    <span style={{color:"Black"}}>ASAP - Order will be ready in 20 Minutes</span></label> :"" }  &nbsp;
                <label >
                    <input type="radio" class="" name="pickupTime" id="Scheduled" value="Scheduled" onChange={this.setValues} required="" aria-required="true" />
                    <span style={{color:"Black"}}>Schedule for later</span>
                </label>
                        </div>
                        {this.state.pickupTime== "Scheduled" ? 
                        <div className="input-field col s6 ">
                       
                        <select  id="picktime" name= "picktime" onChange={this.setValues} defaultValue={this.state.picktime}>
                            <option>Select time</option>
                            {this.state.timeSlots.map((t)=><option value={t}>{t}</option>)}</select>
                        
                        </div>:""}

                        <div className="input-field col s6 ">
                        <label  style={{color:"Black"}} className="col-sm-2 myinfo" htmlFor="allergy"><b>Food Allergy Information</b>(if you have any) :</label>
                        <input  className="col-sm-3 form-control" id="allergy" name= "allergy"  type="text" onChange={this.setValues} defaultValue={this.state.allergy}  required/>
                        </div>
                       
                        <div className="form-inline ">
                        <label  style={{color:"Black"}} className="col-sm-2 myinfo" htmlFor="payType" ><b>Select a Payment Method: </b><span style={{color:"red"}} className="error">* </span></label>  
                        <label >
                    <input type="radio" class="btn"  name="payType" id="Cashnet" value="Credit Card"  onChange={this.setValues} required="" aria-required="true" />
                    <span style={{color:"Black"}}>Credit Card</span></label> &nbsp;
                <label >
                    <input type="radio" class="" name="payType" id="DiningDollars" value="Dining Dollars" onChange={this.setValues} required="" aria-required="true" />
                    <span style={{color:"Black"}}>Dining Dollars (Only for K-State students & staff.)</span>
                </label>
                        </div>
                      
                       <br/> <button className="waves-effect waves-light btn " disabled={disable} onClick={()=>{this.handleCheckOut(this.props)}} >Proceed</button>
                     
                       
                        <Link to="/cart" className="waves-effect waves-light btn ">Cancel</Link><br/>
                        {this.state.loading ? (<div><div class="preloader-wrapper small active">
    <div class="spinner-layer spinner-red-only">
      <div class="circle-clipper left">
        <div class="circle"></div>
      </div><div class="gap-patch">
        <div class="circle"></div>
      </div><div class="circle-clipper right">
        <div class="circle"></div>
      </div>
    </div>
  </div>Loading dining Dollars....</div>):""}
                    </div>
                  
                 </div>
                 </div>
        )
    }
}

const mapStateToProps = (state)=>{
    return{
        orders: state.orders,
        total: state.total,
        
    }
}

const mapDispatchToProps = (dispatch)=>{
    return{
        addShipping: ()=>{dispatch({type: 'ADD_SHIPPING'})},
        substractShipping: ()=>{dispatch({type: 'SUB_SHIPPING'})}
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(CheckOut)
